import axios from "axios";
import uRLs from "./baseUtils";

const AxiosInstance = axios.create({
    baseURL: uRLs.API_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

export default AxiosInstance;